import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { EditOutlined } from '@ant-design/icons';
import { C } from '../../constants/design-tokens';
import { useResponsiveSizes } from '../../../../hooks/use-responsive-sizes';
import { useEditorContext } from '../../context/editor-context';

interface ProjectNameInputProps {
  maxLength?: number;
}

const generateDefaultTitle = () => `Proyecto ${dayjs().format('DD-MM-YYYY')}`;

export const ProjectNameInput: React.FC<ProjectNameInputProps> = ({ maxLength = 80 }) => {
  const { title, onTitleChange } = useEditorContext();
  const { spacing, fontSize } = useResponsiveSizes();
  const [isEditing, setIsEditing] = useState(false);
  const [tempValue, setTempValue] = useState(title);
  const [isCustom, setIsCustom] = useState(false);

  // Autocompleta un título default hasta que el usuario confirme el suyo (aunque sea vacío).
  useEffect(() => {
    if (!title && !isCustom) {
      const defaultTitle = generateDefaultTitle();
      onTitleChange(defaultTitle);
      setTempValue(defaultTitle);
    }
  }, [title, isCustom, onTitleChange]);

  const commit = (value: string) => {
    onTitleChange(value);
    setIsCustom(true);
    setIsEditing(false);
  };

  return (
    <div style={{ marginBottom: spacing.lg }}>
      <style>{`
        .project-name-view:hover { background: ${C.surface}; }
        .project-name-view:hover .project-name-edit-icon { opacity: 1 !important; }
      `}</style>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: spacing.xs }}>
        <span
          style={{
            fontSize: fontSize.sm,
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: 0.6,
            color: C.textLabel
          }}
        >
          Nombre del proyecto
        </span>
        <span style={{ fontSize: fontSize.sm, color: C.textMuted }}>
          {title.length}/{maxLength}
        </span>
      </div>

      {isEditing ? (
        <input
          autoFocus
          value={tempValue}
          maxLength={maxLength}
          onChange={e => setTempValue(e.target.value)}
          onBlur={() => commit(tempValue)}
          onKeyDown={e => {
            if (e.key === 'Enter') commit(tempValue);
          }}
          style={{
            width: '100%',
            boxSizing: 'border-box',
            borderRadius: 8,
            border: `1px solid ${C.borderHi}`,
            outline: 'none',
            fontSize: fontSize.xlg,
            fontWeight: 600,
            padding: `8px ${spacing.sm}px 8px 0`,
            letterSpacing: -0.01,
            fontFamily: 'inherit'
          }}
        />
      ) : (
        <div
          className='project-name-view'
          onClick={() => {
            setTempValue(title);
            setIsEditing(true);
          }}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: spacing.xs,
            cursor: 'text',
            borderRadius: 8,
            padding: `8px ${spacing.sm}px 8px 0`,
            fontSize: fontSize.xlg,
            fontWeight: 600,
            letterSpacing: -0.01,
            transition: 'background 0.15s ease'
          }}
        >
          <span>{title || 'Nombre del video'}</span>
          <EditOutlined
            className='project-name-edit-icon'
            style={{ fontSize: fontSize.sm, color: C.textMuted, opacity: 0, transition: 'opacity 0.2s ease' }}
          />
        </div>
      )}
    </div>
  );
};
